import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type CommunicationLogStatus = 'queued' | 'sent' | 'delivered' | 'read' | 'failed';

export type CommunicationLogDto = {
  id: string;
  leadId: string;
  type: string;
  direction: string;
  message: string;
  status: 'queued' | 'sent' | 'delivered' | 'read' | 'failed';
  metaMessageId?: string;
  sentBy: string;
  responseData?: Record<string, unknown>;
  createdAt?: string;
};

export type SendWhatsappPayload = {
  leadId: string;
  phone: string;
  message: string;
};

export type SendWhatsappResult = {
  logId: string;
  metaMessageId?: string;
  status: 'queued' | 'sent' | 'delivered' | 'read' | 'failed';
};

@Injectable({ providedIn: 'root' })
export class WhatsappService {
  constructor(private readonly api: ApiService) {}

  sendMessage(payload: SendWhatsappPayload) {
    return this.api
      .post<ApiEnvelope<SendWhatsappResult>>('whatsapp/send', payload)
      .pipe(map((r) => r.data));
  }

  getCommunications(leadId: string) {
    return this.api
      .get<ApiEnvelope<CommunicationLogDto[]>>(`whatsapp/communications?leadId=${encodeURIComponent(leadId)}`)
      .pipe(map((r) => r.data));
  }
}
